var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#F3F4F4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9587 7.92079C14.9587 11.4204 11.9822 14.2574 8.3104 14.2574C4.63864 14.2574 1.66208 11.4204 1.66208 7.92079C1.66208 4.42117 4.63864 1.58416 8.3104 1.58416C11.9822 1.58416 14.9587 4.42117 14.9587 7.92079ZM13.6748 13.9706C12.2272 15.1378 10.355 15.8416 8.3104 15.8416C3.72069 15.8416 0 12.2953 0 7.92079C0 3.54626 3.72069 0 8.3104 0C12.9001 0 16.6208 3.54626 16.6208 7.92079C16.6208 9.77105 15.9552 11.4731 14.8397 12.8214L20 19.0148L18.6984 20L13.6748 13.9706Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7b99e69a07e6f0a61179d8e863345170.svg";
export { ForwardRef as ReactComponent };